export enum RoleEnum {
  ADMINISTRADOR = "ADMINISTRADOR",
  USER = "USER",
  ANALISTA = "ANALISTA",
}
